import user from './user'
import options from './options'

const ducks = {
	user,
	options
}
export default ducks
